export const Buyers = {
	heading: 'For Buyers',
	description:
		'Find your next best product faster. Search and sort by velocity, category, ingredient, brand, product - all in one place, without the hassle.',
	brandMetricsText: 'Certified Brands',
	brandMetricsValue: '5,900+',
	productMetricsText: 'Quality Products',
	productMetricsValue: '30,000+',
	productsButton: 'Discover Products',
	whatsNew: 'Get inspired by what’s new'
};

export const Brands = {
	heading: 'For Brands',
	description:
		'Showcase your products year-round with Beacon Discovery and guide buyers to them at Expo. Expand your retail reach.',
	netSalesText: 'Net Retail Sales Growth',
	netSalesValue: '$368M+',
	avgVelocityText: 'Average Velocity Lift ($/store/week)',
	avgVelocityValue: '$5.71',
	acvText: 'ACV Distribution Increase',
	acvValue: '+1.57%',
	getOnBeaconButton: 'Exhibit your products',
	productsButton: 'Explore the platform'
};

export const verifiedLabel = 'Verified by New Hope Network’s Standards team';
